var _desc, _defs, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pin-stop",
    style: {
      fillRule: "evenodd",
      fill: "none"
    }
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 0c-5.5111 0-10.002 4.5378-10.002 10.111 0 4.0617 2.4223 7.8664 4.7586 10.702 2.3364 2.8352 4.6727 4.7254 4.6727 4.7254l0.57035 0.46211 0.57035-0.46211s2.3364-1.8902 4.6727-4.7254c2.3364-2.8352 4.7552-6.6398 4.7552-10.702 0-5.5732-4.4872-10.111-9.9983-10.111",
    style: {
      fill: "#800080"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 4.598,
    y: 15.832971,
    style: {
      fill: "#ffffff",
      fontFamily: "sans-serif",
      fontSize: 40,
      letterSpacing: 0,
      lineHeight: 1.25,
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.598,
    y: 15.832971,
    style: {
      fontFamily: "sans-serif",
      fontSize: 16
    }
  }, "A"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSensor);
export default __webpack_public_path__ + "static/media/pin-sensor.493462e92469a1bdced9389c49ff0692.svg";
export { ForwardRef as ReactComponent };